import { defineStore } from "pinia";
import { encryptData, decryptData } from "@/Utils/SecureStorage";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    loginResponse: {},
  }),
  actions: {
    setLoginResponse(response) {
      this.loginResponse = response;
    },
    logout() {
      this.loginResponse = {};
    },
  },
  persist: {
    key: "auth_store",
    storage: {
      getItem: (key) => {
        const encryptedData = localStorage.getItem(key);
        return encryptedData ? decryptData(encryptedData) : null;
      },
      setItem: (key, value) => {
        localStorage.setItem(key, encryptData(value));
      },
      removeItem: (key) => {
        localStorage.removeItem(key);
      }
    }
  }

});
